import "chartjs-adapter-moment";
import React from "react";
import { useSelector } from "react-redux";

import { CommentList } from "@/components/home/CommentList/components/CommentList";
import { InformationBoard } from "@/components/home/InformationBoard/components/InformationBoard";
import { ProgressDashboard } from "@/components/home/ProgressDashboard/components/ProgressDashboard";
import { RootState } from "@/reducers/types";

export const Home = () => {
  const { masters, construction } = useSelector((state: RootState) => state.construction);

  if (!masters || !construction) return <></>;

  return (
    <div className="w-full h-[calc(100%-65px)] flex flex-col justify-between px-[15px]">
      <div className="h-[50%]">
        <ProgressDashboard />
      </div>
      <div className="flex w-full h-[50%]">
        <div className="w-[50%] pb-[15px] pr-[7px]">
          <InformationBoard />
        </div>
        <div className="w-[50%] pb-[15px] pl-[7px]">
          <CommentList />
        </div>
      </div>
    </div>
  );
};
